import cursor from '../../cursor'

export default {
  methods: {
    toggleCursor(enable) {
      cursor.setColorClass('bg-black c-white')
      cursor.toggleDisplay(enable)
    },
    toggleActiveCursor(enable) {
      cursor.toggleActiveState(enable)
    },
  },
}
